import React from 'react';
import { TabNavigation, TabId } from './TabNavigation';
interface HeaderProps {
  activeTab: TabId;
  onTabChange: (id: TabId) => void;
}
export function Header({
  activeTab,
  onTabChange
}: HeaderProps) {
  return <header className="sticky top-0 z-50 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-gray-200 shadow-sm" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        <div className="flex items-center justify-between px-4 py-4 md:py-6" data-id="element-94">
          <div className="flex items-center" data-id="element-95">
            {/* Logo + Product Name */}
            <a href="#" onClick={e => {
            e.preventDefault();
            onTabChange('overview');
          }} className="flex items-center space-x-3 hover:opacity-80 transition-opacity" data-id="element-96">
              <span className="text-2xl font-bold tracking-tight" data-id="element-97">
                <span className="text-[#1e3a5f]" data-id="element-98">Provenance</span>
                <span className="text-[#4db8a4]" data-id="element-99">One</span>
              </span>
              <span className="text-xl font-semibold text-gray-400 tracking-tight" data-id="element-100">
                :
              </span>
              <span className="text-xl font-bold tracking-tight text-black" data-id="element-101">
                MCPGuard
              </span>
            </a>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-102">
            <button onClick={() => onTabChange('early-access')} className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" data-id="element-103">
              Request Access &rarr;
            </button>
          </div>
        </div>

        {/* Navigation Tabs */}
        <TabNavigation activeTab={activeTab} onTabChange={onTabChange} data-id="element-104" />
      </div>
    </header>;
}